<template>
  <svg viewBox="0 0 28 66" xmlns="http://www.w3.org/2000/svg">
    <path
      d="m0 52.65c-.003-.16.057-.32.178-.443.243-.248.645-.254.895-.015l12.292 11.711v-63.28c0-.344.284-.623.633-.623s.633.279.633.623v63.281l12.292-11.714c.251-.239.652-.232.895.015.119.121.181.277.181.433 0 .163-.066.327-.195.45l-13.366 12.736c-.246.234-.635.234-.88 0l-13.365-12.735c-.126-.12-.19-.279-.193-.438z"
    />
  </svg>
</template>
